import "./bootstrap";
import { trackEvent, trackOutbound } from "./analytics";
import Alpine from "@alpinejs/csp";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import "./components/stat-counter";

window.skylaneAnalytics = { trackEvent, trackOutbound };

// Delegated analytics click handler — replaces inline onclick attributes (blocked by CSP).
// Usage: data-track-event="email-click" data-track-page="footer"
document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track-event]');
    if (!el) return;

    var name = el.dataset.trackEvent;
    var data = {};

    if (el.dataset.trackPage) data.page = el.dataset.trackPage;
    if (el.dataset.trackPagePath) data.page = window.location.pathname;

    trackEvent(name, data);
});

Alpine.plugin(focus);
Alpine.plugin(intersect);

window.Alpine = Alpine;
Alpine.start();

// Hero video controller — single <video>, sources injected per viewport
(function () {
    var video = document.getElementById('heroVideo');
    var toggle = document.getElementById('heroVidToggle');
    if (!video || !toggle) return;

    var pauseIcon = '<svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
    var playIcon = '<svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="6 3 20 12 6 21 6 3"/></svg>';
    var paused = false;
    var currentSize = null;
    var mdQuery = window.matchMedia('(min-width: 768px)');
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Inject <source> elements for the correct viewport, then load + play
    function loadSources(forceMP4) {
        var size = mdQuery.matches ? 'desktop' : 'mobile';
        if (size === currentSize && !forceMP4) return;
        currentSize = size;

        // Clear existing sources
        while (video.firstChild) video.removeChild(video.firstChild);

        if (!forceMP4) {
            // Try WebM first (smaller file)
            var webm = document.createElement('source');
            webm.src = video.dataset[size + 'Webm'];
            webm.type = 'video/webm';
            // If WebM source fails, retry with MP4 only
            webm.addEventListener('error', function () {
                currentSize = null; // reset guard so loadSources re-runs
                loadSources(true);
            });
            video.appendChild(webm);
        }

        // MP4 fallback (or primary if WebM failed)
        var mp4 = document.createElement('source');
        mp4.src = video.dataset[size + 'Mp4'];
        mp4.type = 'video/mp4';
        video.appendChild(mp4);

        // Reset opacity for fresh load
        video.classList.remove('is-loaded');
        video.load();

        if (!paused && !motionQuery.matches) {
            video.play().catch(function () {});
        }
    }

    // Fade in once actually playing
    video.addEventListener('playing', function () {
        video.classList.add('is-loaded');
    });

    // If video decode fails (e.g. WebM codec not supported), retry with MP4 only
    video.addEventListener('error', function () {
        if (video.error && video.error.code === 3) {
            loadSources(true);
        }
    });

    function updateToggleIcon() {
        if (video.paused) {
            toggle.innerHTML = playIcon;
            toggle.setAttribute('aria-label', 'Play background video');
        } else {
            toggle.innerHTML = pauseIcon;
            toggle.setAttribute('aria-label', 'Pause background video');
        }
    }

    // Pause / play toggle
    toggle.addEventListener('click', function () {
        if (video.paused) {
            video.play();
            paused = false;
        } else {
            video.pause();
            paused = true;
        }
        updateToggleIcon();
    });

    // Swap sources on viewport change (e.g. device rotation)
    mdQuery.addEventListener('change', function () {
        loadSources();
        updateToggleIcon();
    });

    // Respect prefers-reduced-motion
    motionQuery.addEventListener('change', function () {
        if (motionQuery.matches) {
            video.pause();
        } else if (!paused) {
            video.play().catch(function () {});
        }
        updateToggleIcon();
    });

    // Initial load — inject sources for current viewport and play
    if (!motionQuery.matches) {
        loadSources();
    }
})();
